import * as React from 'react';

import { MessagePreviewItem } from '../../messages/components/message-preview-item';

import { MESSAGE_TYPE, MessageType } from '../../util/message-types';
import Message from '../../widgets/legacy-message';

type Props = {
  parser: MessageTemplateParser;
  message: {
    template: string;
    isConfirmationRequired: boolean;
  };
  sender?: string;
  messageType: MessageType;
  templateType: TemplateType;
  onChange: (template: string) => void;
  onError: () => void;
};

type State = {
  error: string | null;
  template: string | null;
};

export class MessageTemplatePreview extends React.PureComponent<Props, State> {
  state: State = {
    error: null,
    template: null,
  };

  componentDidMount() {
    this.updateMessage();
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.message.template !== this.props.message.template ||
      prevProps.message.isConfirmationRequired !== this.props.message.isConfirmationRequired
    ) {
      this.updateMessage();
    }
  }

  updateMessage = () => {
    const { parser, message, onError, onChange } = this.props;
    try {
      const template = parser.parse(message.template, Boolean(message.isConfirmationRequired));
      this.setState({
        error: null,
        template,
      });
      onChange(template);
    } catch (e: any) {
      if (e?.message?.includes('Unclosed')) {
        this.setState({
          error: 'You have an invalid message template. Please close all of your brackets.',
        });
      }
      onError();
    }
  };

  render() {
    const { messageType, templateType, sender } = this.props;
    const { error, template } = this.state;

    const messagePreview = (
      <MessagePreviewItem
        messageType={messageType}
        className="u-margin-y"
        messageBody={error || template || ''}
        recipientName="The Applicant"
        subject="About your application"
        dataCy={`message-template-preview-${messageType}`}
        senderName={
          messageType === MESSAGE_TYPE.TEXT && sender ? sender : 'Team Engine (automatically)'
        }
        includesHTML={messageType === MESSAGE_TYPE.TEXT}
      />
    );

    const commentPreview = (
      <Message
        className="u-margin-y-sm"
        canBeDismissed={false}
        dataCy="message-template-preview-message"
      >
        <div dangerouslySetInnerHTML={{ __html: template || '' }} />
      </Message>
    );

    return templateType === 'message' ? messagePreview : commentPreview;
  }
}
